// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2i31U","rootMobile":"styles_rootMobile__1Z9zL"};